import Vue from 'vue';

import { MutationTree } from 'vuex/types';
import { InstallationState, InstallationModuleStatus } from '.';
import { AsyncMutationTree } from 'vuex-async-mutations';
import { InstallationModuleData } from '@/types';

export const mutationsAsync: AsyncMutationTree<InstallationState> = {
  ['fetch']: {
    pending(state, id: number) {
      let installation = state.installations[id];

      if (!installation) {
        installation = { modules: {}, status: {} };
        Vue.set(state.installations, id, installation);
      }
    },
  },

  ['save']: {
    resolved(state, result, { id, moduleType }: { id: number; moduleType: string }) {
      Vue.delete(state.installations[id].modules, moduleType);
    },
  },

  [`poll`]: {
    pending(state, { id, type, context, pollTimeoutId = -1 }) {
      let installation = state.installations[id];

      const status: InstallationModuleStatus = {
        status: 'processing',
        context,
        pollTimeoutId,
      };

      Vue.set(installation.status, type, status);
    },

    resolved(state, payload: InstallationModuleStatus, { id, type, context, pollTimeoutId }) {
      let installation = state.installations[id];

      if (payload.status === 'success') {
        Vue.delete(installation.status, type);
        return;
      }

      const status: InstallationModuleStatus = {
        ...payload,
        context,
        pollTimeoutId,
      };

      Vue.set(installation.status, type, status);
    },

    rejected(state, payload: Error, { id, type, context, pollTimeoutId = -1 }) {
      let installation = state.installations[id];

      const status: InstallationModuleStatus = {
        status: 'error',
        error: payload.message,
        context,
        pollTimeoutId,
      };

      Vue.set(installation.status, type, status);
    },
  },
};

export const mutations: MutationTree<InstallationState> = {
  ['set:module'](
    state,
    {
      id,
      moduleType,
      data,
    }: { id: number; moduleType: string; data: Partial<InstallationModuleData> },
  ) {
    const mod = state.installations[id].modules[moduleType];

    Vue.set(state.installations[id].modules, moduleType, {
      ...mod,
      data: JSON.parse(JSON.stringify(data)),
    });
  },

  ['reset'](state) {
    state.installations = {};
  },
};
